import { render, staticRenderFns } from "./CmsProductHistorySelector.vue?vue&type=template&id=e54e3db8&scoped=true&"
import script from "./CmsProductHistorySelector.vue?vue&type=script&lang=js&"
export * from "./CmsProductHistorySelector.vue?vue&type=script&lang=js&"
import style0 from "./CmsProductHistorySelector.vue?vue&type=style&index=0&id=e54e3db8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e3db8",
  null
  
)

export default component.exports